import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { protectedResources } from 'src/app/auth/auth.config';
import {
  AircraftsRegistrationPlan,
  AircraftsRegistrationResponse,
} from '../models/aircraft-registration.model';
@Injectable({
  providedIn: 'root',
})
export class AircraftRegistrationService {
  private apiEndpoint: string = protectedResources.apiTodoList.endpoint;

  constructor(private http: HttpClient) {}

  applyAircraftsRegistration(
    plan: AircraftsRegistrationPlan,
  ): Observable<AircraftsRegistrationResponse[]> {
    return this.http.post<AircraftsRegistrationResponse[]>(
      `${this.apiEndpoint}/admin/aircraftsRegistration`,
      plan,
    );
  }
}
